import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { BILLING_METHOD_OPTIONS } from "../constants/billing";
/**
 * 월구독 빌링 결제수단 선택
 *
 * 탭이 아니라 단일 선택이므로 RadioGroup을 사용한다. (화살표 키 이동 / role="radiogroup" 위임)
 * 결제수단이 3~4개로 늘어날 수 있어 고정 2분할 대신 wrap 되는 레이아웃으로 둔다.
 */ export const BillingMethodSelector = (param)=>{
    let { method , onMethodChange  } = param;
    return /*#__PURE__*/ _jsx(RadioGroup.Root, {
        className: "flex flex-wrap gap-2",
        value: method,
        onValueChange: (value)=>onMethodChange(value),
        "aria-label": "결제수단",
        children: BILLING_METHOD_OPTIONS.map((param)=>/*#__PURE__*/ {
            let { value , label  } = param;
            return _jsx(RadioGroup.Item, {
                value: value,
                className: cn("group flex h-14 min-w-[140px] flex-1 items-center justify-center", "rounded-md border border-gray-200 bg-white px-6 py-4 transition-colors", "data-[state=checked]:border-primary-main data-[state=checked]:bg-indigo-50"),
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle1",
                    as: "span",
                    className: "text-primary group-data-[state=checked]:text-primary-main",
                    children: label
                })
            }, value);
        })
    });
};
